/**
 * Pin validation constants
 */
export const PinValidation = {
    latitude: { min: -90, max: 90 },
    longitude: { min: -180, max: 180 },
    accuracy: { max: 20 }, // meters
    itemCount: { min: 1, max: 10 },
};
/**
 * Validates if GPS accuracy meets requirements
 */
export function isValidGpsAccuracy(accuracy) {
    return accuracy > 0 && accuracy <= PinValidation.accuracy.max;
}
/**
 * Validates latitude value
 */
export function isValidLatitude(lat) {
    return lat >= PinValidation.latitude.min && lat <= PinValidation.latitude.max;
}
/**
 * Validates longitude value
 */
export function isValidLongitude(lng) {
    return lng >= PinValidation.longitude.min && lng <= PinValidation.longitude.max;
}
/**
 * Validates item count
 */
export function isValidItemCount(count) {
    return (Number.isInteger(count) &&
        count >= PinValidation.itemCount.min &&
        count <= PinValidation.itemCount.max);
}
//# sourceMappingURL=pin.js.map